export default {"src":"/cbr/_next/static/media/user-small.a3579ec8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};